import _ from 'lodash';
import React, { Component } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import AppRedirect from './AppRedirect';
import SignInSignUpSwitcher from './SignInSignUpSwitcher';
import AssociateMfaComponent from './Mfa/AssociateMfa';
import ValidateMfaComponent from './Mfa/ValidateMfa';
import VerifyEmail from './VerifyEmail';

import { Options } from '../types';

const Login = (props: Options) => <SignInSignUpSwitcher signin options={props} />;

const Signup = (props: Options) => <SignInSignUpSwitcher options={props} />;

const AppRedirectRoute = () => <AppRedirect redirectUrl={_.get(window.socrata, 'redirectUrl', '')} />;

interface Props {
  config: Options;
}

class Authentication extends Component<Props> {
  render() {
    const { config } = this.props;
    const {
      associateMfaPath,
      flashes,
      loginPath,
      mfaBarcodeUri,
      signupPath,
      validateMfaPath,
      validateOtpPath,
      cancelMfaPath,
      verifyEmailPath,
      companyName,
    } = config;

    return (
      <BrowserRouter>
        <Routes>
          <Route path={loginPath} element={<Login {...config} />} />
          <Route path={signupPath} element={<Signup {...config} />} />
          <Route
            path={associateMfaPath}
            element={
              <AssociateMfaComponent
                flashes={flashes}
                mfaBarcodeUri={mfaBarcodeUri}
                validateOtpPath={validateOtpPath}
                cancelMfaPath={cancelMfaPath}
              />
            }
          />
          <Route
            path={validateMfaPath}
            element={
              <ValidateMfaComponent
                flashes={flashes}
                validateOtpPath={validateOtpPath}
                cancelMfaPath={cancelMfaPath}
              />
            }
          />
          <Route
            path={verifyEmailPath}
            element={
              <VerifyEmail
                loginPath={loginPath}
                verifyEmailPath={verifyEmailPath}
                companyName={companyName}
              />
            }
          />
          <Route path="/app_redirect" element={<AppRedirectRoute />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default Authentication;
